import { useRef, useState } from "react";
import { Camera, Loader2, ReceiptText, X } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";

export const ReceiptScanButton = ({ tid, receiptId, onScanned, onClear }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const scan = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/receipts/scan", fd);
      onScanned(data);
      toast[data.suggestion ? "success" : "message"](data.suggestion ? "Ticket lu : vérifiez les champs avant d'ajouter" : "Photo jointe, mais le ticket n'a pas pu être lu");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <div className="flex items-center gap-2 sm:col-span-2 lg:col-span-5">
      <input ref={ref} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => scan(e.target.files?.[0])} data-testid={`${tid}-receipt-input`} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy}
        className="flex items-center gap-2 rounded-full border border-dashed border-border px-3 py-1.5 text-xs font-semibold text-muted-foreground transition-colors hover:bg-secondary" data-testid={`${tid}-receipt-button`}>
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Camera className="h-3.5 w-3.5" />}
        {busy ? "Lecture du ticket…" : receiptId ? "Remplacer le ticket" : "Ticket de caisse en photo (facultatif)"}
      </button>
      {receiptId && <span className="tone-chip tone-mint flex items-center gap-1 rounded-full px-2.5 py-1 text-xs" data-testid={`${tid}-receipt-attached`}><ReceiptText className="h-3.5 w-3.5" />Ticket joint
        <button type="button" onClick={onClear} aria-label="Retirer le ticket" data-testid={`${tid}-receipt-clear`}><X className="h-3 w-3" /></button></span>}
    </div>
  );
};

export const ReceiptView = ({ id, tid }) => {
  const [url, setUrl] = useState(null);
  const open = async () => {
    try { const r = await api.get(`/receipts/${id}`, { responseType: "blob" }); setUrl(URL.createObjectURL(r.data)); } catch (e) { toast.error(formatApiError(e)); }
  };
  const close = () => { URL.revokeObjectURL(url); setUrl(null); };
  return (
    <>
      <button onClick={open} className="text-muted-foreground hover:text-foreground" aria-label="Voir le ticket" data-testid={`${tid}-receipt-view-${id}`}><ReceiptText className="h-4 w-4" /></button>
      <Dialog open={!!url} onOpenChange={(o) => !o && close()}>
        <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="receipt-dialog">
          <DialogHeader><DialogTitle className="font-heading">Ticket de caisse</DialogTitle></DialogHeader>
          {url && <img src={url} alt="Ticket de caisse" className="w-full rounded-xl" />}
        </DialogContent>
      </Dialog>
    </>
  );
};
